const d = (s) => new Date(s + "T00:00:00");
const SPOT_DAYS = 5;
const daysBetween = (a, b) => Math.round((d(b) - d(a)) / 86400000);

export const enquiryDay = (r) => r.inputs?.enquiryDate || new Date(r.created_at).toLocaleDateString("en-CA");

const istDay = (dt = new Date()) => dt.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
export const lagDays = (date) => (date ? daysBetween(date, istDay()) : 0);
export const recLag = (pay) => (pay?.recorded_at && pay?.date ? daysBetween(pay.date, istDay(new Date(pay.recorded_at))) : 0);

export const spotIssues = (enq, formFee, payDate) => {
  const out = [];
  if (!formFee) out.push("Form fee of Rs.1000 not recorded");
  else if (formFee.date !== enq) out.push("Form fee was not paid on the enquiry date");
  if (formFee && Number(formFee.amount) < 1000) out.push("Form fee is less than Rs.1000");
  if (recLag(formFee) >= 2) out.push(`Form fee was recorded ${recLag(formFee)} days after it was paid`);
  if (payDate && (payDate < enq || daysBetween(enq, payDate) > SPOT_DAYS)) out.push("Admission fee was not paid within 5 days of the enquiry");
  if (lagDays(payDate) >= 2) out.push(`Admission fee was recorded ${lagDays(payDate)} days after it was paid`);
  return out;
};

export const admissionWarn = (r) => (r.inputs?.spot ? (date) => spotIssues(enquiryDay(r), r.form_fee, date) : null);
export const formFeeWarn = (r) => (r.inputs?.spot ? (date) => [
  ...(date && date !== enquiryDay(r) ? ["Form fee was not paid on the enquiry date"] : []),
  ...(lagDays(date) >= 2 ? [`Form fee is being recorded ${lagDays(date)} days after it was paid`] : []),
] : null);

export const partsOf = (r) => (r?.partial_payments?.length ? r.partial_payments : r?.partial_payment ? [r.partial_payment] : []);
const partsPaid = (r) => partsOf(r).reduce((t, x) => t + (Number(x.amount) || 0), 0);
export const admissionDue = (r) =>
  Math.max(0, (r.computed?.atAdmission || 0) - (Number(r.form_fee?.amount) || 0) - partsPaid(r)) || "";
export const partialDue = (r) => Math.max(0, (r.computed?.atAdmission || 0) - (Number(r.form_fee?.amount) || 0) - partsPaid(r));
export const partialCfg = (r) => ({ due: partialDue(r), hasFormFee: !!r.form_fee, onlyFormFee: false, balanceDate: r.follow_up_date });

export const partOf = (r) => {
  if (!r) return null;
  if (r.status === "partial") return { parts: partsOf(r), balance: Number(admissionDue(r)) || 0, by: r.follow_up_date };
  return r.status === "admitted" && partsOf(r).length ? { parts: partsOf(r), balance: null } : null;
};

export const spotCountdown = (r) => {
  if (!r?.inputs?.spot || r.status === "admitted" || r.status === "not_interested") return null;
  const left = SPOT_DAYS - daysBetween(enquiryDay(r), new Date().toLocaleDateString("en-CA"));
  const end = d(enquiryDay(r));
  end.setDate(end.getDate() + SPOT_DAYS);
  const on = end.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
  if (left < 0) return { left, tone: "over", label: `Spot window over (ended ${on})` };
  if (left === 0) return { left, tone: "urgent", label: "Spot ends today" };
  return { left, tone: left <= 1 ? "urgent" : left <= 2 ? "soon" : "ok", label: `Spot ends in ${left} day${left === 1 ? "" : "s"} (${on})` };
};
